import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BASE_URL} from "../../app.environment";

@Injectable({
    providedIn: 'root'
})
export class ImageUploaderService {

    httpClient = inject(HttpClient)

    constructor() {
    }

    uploadImage(formData: FormData) {
        return this.httpClient.post(`${BASE_URL}/upload`, formData)
    }

    dataURLToBlob(dataURL: string) {
        const parts = dataURL.split(',');
        const byteString = atob(parts[1]);
        const mimeString = parts[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    }
}
